<template>
  <div>
    新竹超才：新竹物流運費包含運送1才內的包裹(1才=長*寬*高/27000)，每超過1才加收25元超才費。
    <!-- 考量到丈量包裹外包裝可能有微小誤差，巧巧郎將再額外吸收2才超才費，當包裹才積超過{{ transport==='air'?'4': '6' }}才時，您才需承擔超才費用。 -->

    <template v-if="isPersonal">
      <br>
      <br>
      *部分倉庫免費，則由巧巧郎吸收新竹超才費用。<br>
      *家具類貨物不適用免新竹超才費優惠，推薦走漳州倉海運。
    </template>
  </div>
</template>
<script>
export default {
  props: {
    transport: String,
    addrid: String,
    isPersonal: Boolean,
  }
}
</script>
